export const home = {
  trackYourMatches: '追踪你的比赛',
  startRecording: '开始记录',
  recordNewMatch: '记录新比赛',
  trackYourLatestGame: '追踪你的最新比赛',
  realTimeScoring: '场上工具',
  liveScoreboard: '计分器',
  trackPointsInRealTime: '边打边记，告别纸笔',
  manageTournaments: '管理锦标赛',
  viewAndCreateTournaments: '查看和创建锦标赛',
  recentMatches: '最近比赛',
  noMatchesYet: '暂无比赛',
  noMatchesDescription: '记录第一场比赛，开始追踪你的网球之路。',
  recordAMatch: '记录比赛',
  pickupTitle: '约球',
  pickupSubtitle: '找球友、约球场',
  pickupEyebrow: '实时发布',
  leaderboardTitle: '排行榜',
  leaderboardSubtitle: '看看你在哪个位置',
  leaderboardEyebrow: '全球排名',
  pendingConfirmations: '有 {{count}} 场比赛等你确认',
  leagueEyebrow: 'Acework 积分赛',
  leagueTitle: '月度排位赛',
  leagueSubtitle: '每月 5 场 · 冲段拼分',
  clubsEyebrow: '社群',
  clubsTitle: '俱乐部',
  clubsSubtitle: '加入或创建网球社群',
  myClubs: '我的俱乐部',
  seeAll: '全部 ›',
  enableNotifications: '开启推送通知',
  enableNotificationsDesc: '有人加入你的约球或比赛时收到提醒',
};
